import Loader from 'components/Common/Loader'
import Modal from 'components/Common/Modal/Modal'
import Select from 'components/Common/Select/Select'
import { useEffect, useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'
import { updateProductionItemReceivedQuantity } from 'store/actions'

const useSimulateScanModalForReception = ({
	order,
	afterSuccess,
	isOpen,
	setIsOpen,
	orderItem,
}) => {

	const { t } = useTranslation('naming')
	const updateProductionItemReceivedQuantityCallStatus = useSelector(state => state.Orders.updateProductionItemReceivedQuantityCallStatus)
	const dispatch = useDispatch()

	const [quantitySelected, setQuantitySelected] = useState(1)
	const [orderFragmentIdSelected, setOrderFragmentIdSelected] = useState(null)
	useEffect(() => {
		if (!isOpen) return
		if (updateProductionItemReceivedQuantityCallStatus.loading == false) {
			if (updateProductionItemReceivedQuantityCallStatus.success == true) {
				// EXITO: Cierra el modal y actualiza el front para no tener que recargar la página para ver los cambios:
				setIsOpen(false)
				afterSuccess({
					partId: orderItem.partId,
					quantity: quantitySelected,
					orderFragmentId: orderFragmentIdSelected,
				})
			} else if (updateProductionItemReceivedQuantityCallStatus.error != null) {
				// ERROR: Muestra un mensaje de error:
				alert(t('error_message'))
			}
		}
	}, [updateProductionItemReceivedQuantityCallStatus.loading])

	const productionOptions = useMemo(() => {
		if (order == null || orderItem == null || order.productions == null) return []
		const productionsOfThisOrderItemByPartId = order.productions
			.filter(p => p.productionItemList
				.find(pi => pi.part.id == orderItem.partId && pi.receivedQuantity < pi.totalQuantity))
		return Array.from({ length: productionsOfThisOrderItemByPartId.length })
			?.map((_, i) => {
				const production = productionsOfThisOrderItemByPartId[i]
				return {
					label: production.displayId,
					value: production.orderFragmentId,
				}
			})
	}, [orderItem])



	const quantityOptions = useMemo(() => {
		if (order == null || order.productions == null || orderFragmentIdSelected == null) return []
		const productionItem = order.productions
			.find(p => p.orderFragmentId == orderFragmentIdSelected).productionItemList
			.find(pi => pi.part.id == orderItem.partId)

		const options = Array.from({
			length: productionItem?.totalQuantity,
		})?.map((_, i) => ({
			label: i + 1, value: i + 1,
		}))

		return options

	}, [productionOptions, orderFragmentIdSelected, order?.productions, orderItem])

	const SimulateScanModalForReception = useMemo(() => (
		<Modal
			isOpen={isOpen}
			closeModal={() => setIsOpen(false)}
			title={t('scanPart')}
			closeButtonColor="secondary"
			body={
				<div>
					<div className='px-5 my-3' style={{
						display: 'grid',
						gridTemplateColumns: 'repeat(3, 1fr)',
						gap: '1rem',
						alignItems: 'center',
						width: '100%',
					}}>
						<div>
							{t('production')}{':'}
						</div>
						<Select
							value={orderFragmentIdSelected}
							onChange={e => setOrderFragmentIdSelected(Number(e.currentTarget.value))}
							options={productionOptions}
							classNamePrefix="select2-selection"
						/>
						<div />
						<div>
							{t('quantity')}{':'}
						</div>
						<Select
							value={quantitySelected}
							onChange={e => setQuantitySelected(Number(e.currentTarget.value))}
							options={quantityOptions}
							classNamePrefix="select2-selection"
							disabled={orderFragmentIdSelected == null}
						/>
						<div />
					</div>
				</div>
			}
			buttons={[(
				<button
					key={'saveScannedQuantityButton'}
					className='btn btn-primary'
					onClick={() => {
						dispatch(updateProductionItemReceivedQuantity({
							data: {
								orderId: orderItem.orderId,
								partId: orderItem.partId,
								quantity: quantitySelected,
								orderFragmentId: orderFragmentIdSelected,
							},
						}))
					}}
					disabled={updateProductionItemReceivedQuantityCallStatus.loading}
				>
					{updateProductionItemReceivedQuantityCallStatus.loading ? (
						<div className="d-flex justify-content-center align-items-center">
							<Loader />
						</div>
					) : t('save')}
				</button>
			)]}
		/>
	), [
		isOpen,
		orderItem,
		quantityOptions,
		quantitySelected,
	])

	return {
		SimulateScanModalForReception,
	}
}

export default useSimulateScanModalForReception
